/**
 * Route for `click-counts`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ClickCountsPage } from "../features/click-counts/ClickCountsPage";

export const clickCountsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/click-counts",
	component: ClickCountsPage,
});

export default clickCountsRoute;
